import { Controller } from "@hotwired/stimulus";
import { createApp } from "vue";
import { pinia } from "/stores";
import UserList from "/vue/user_list";

export default class extends Controller {
  initialize() {
    this.app = createApp(UserList).use(pinia);
  }

  connect() {
    this.app.mount(this.element);
  }

  disconnect() {
    this.app.unmount();
  }
}
